import { Component } from 'react'

export class FilterBar extends Component {

	render() {
		return (
			<div className="bi-filter-bar">
				<div className="container container-full">
					<div className="row">
						<div className="col-12">
							<ul>
								<li><button onClick={ () => this.props.updateCategory( false ) } className={`${ this.props.currentCategory === false ? 'active' : '' }`}>All</button></li>
								{this.props.categories.map((category, index) => {
									return (
										<li key={ index }>
											<button 
												onClick={ () => this.props.updateCategory( category.id ) }
												className={`${ this.props.currentCategory === category.id ? 'active' : '' }`}
											>{ category.name }</button>
										</li>
									)
								})}
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	}

}